<template>
    <DefaultLayout :footer="false"> </DefaultLayout>
</template>

<script>
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

export default {
    setup() {
        const store = useStore()
        const route = useRoute()

        return {
            store,
            route,
        }
    },
    created() {
        // error set from router during a 404
        this.store.state.global.data.showErrorPage = true
    },
}
</script>
